module.exports = __webpack_public_path__ + "static/media/car-left-shadow.81253778.png";